import React, { Component } from "react";
import CannedDriverMessages from './CannedDriverMessages';

const CannedMessageSettings = () => {
  return (
    <div className="w-full">
      <CannedDriverMessages isBrokerShipmentManagement={0}/>
      <CannedDriverMessages isBrokerShipmentManagement={1}/>
    </div>
  );
}

export default CannedMessageSettings;
